import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { authService } from '../../modules/auth/services/authService';

const RoleSelectionRoute = () => {
  const isAuthenticated = authService.isAuthenticated();

  if (!isAuthenticated) {
    return <Navigate to="/auth/login" replace />;
  }

  return <Outlet />;
};

export default RoleSelectionRoute; 